import { JobService } from "@/modules/job/job-service";
import jobListExporterFields from "@/modules/job/job-list-exporter-fields";
import Errors from "@/shared/error/errors";
import Exporter from "@/shared/exporter/exporter";
import { firestoreAction, vuexfireMutations } from "vuexfire";
import firebase from "firebase/app";

const INITIAL_PAGE_SIZE = 20;

export default {
  namespaced: true,

  state: {
    rows: [],
    rowsFromRoute: [],
    // //#region  vuexfire variables
    loadMoreLastRecord: null,
    loadFirstRecord: null,
    recordAfterLast: [],
    recordBeforeFirst: [],
    totalRecords: null,
    pagesNumber: null,
    mountedTable: false,
    userJobs: [],
    // //#endregion

    count: 0,
    loading: false,
    backgroundLoading: false,
    filter: {},
    pagination: {},
    sorter: {},

    table: null,
  },

  getters: {
    backgroundLoading: (state) => state.backgroundLoading,
    loading: (state) => state.loading,

    exportLoading: (state) => state.exportLoading,

    rows: (state) => state.rows || [],
    // //#region vuexfire getters
    rowsFromRoute: (state) => state.rowsFromRoute,

    mountedTable: (state) => state.mountedTable,
    loadMoreLastRecord: (state) => {
      return state.loadMoreLastRecord;
    },
    loadFirstRecord: (state) => {
      return state.loadFirstRecord;
    },
    recordAfterLast: (state) => state.recordAfterLast,
    recordBeforeFirst: (state) => state.recordBeforeFirst,
    totalRecords: (state) => state.totalRecords,
    pagesNumber: (state) => state.pagesNumber,
    userJobs: (state) => state.userJobs,
    // //#endregion
    count: (state) => state.count,

    hasRows: (state, getters) => getters.count > 0,

    orderBy: (state) => {
      const sorter = state.sorter;

      if (!sorter) {
        return null;
      }

      if (!sorter.prop) {
        return null;
      }

      let direction = sorter.order === "descending" ? "DESC" : "ASC";

      return `${sorter.prop}_${direction}`;
    },

    filter: (state) => state.filter,

    limit: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return INITIAL_PAGE_SIZE;
      }

      return pagination.pageSize;
    },

    offset: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return 0;
      }

      const currentPage = pagination.currentPage || 1;

      return (currentPage - 1) * pagination.pageSize;
    },

    pagination: (state, getters) => {
      return {
        ...state.pagination,
        total: getters.count,
        showSizeChanger: true,
      };
    },

    selectedRows: (state) => {
      return state.table ? state.table.selection : [];
    },
  },

  mutations: {
    RESETED(state) {
      state.rows = [];
      state.count = 0;
      state.loading = false;
      state.filter = {};
      state.pagination = {};
      state.sorter = {};
      if (state.table) {
        state.table.clearSelection();
      }
    },

    UNSELECT_ALL(state) {
      if (state.table) {
        state.table.clearSelection();
      }
    },

    TABLE_MOUNTED(state, payload) {
      state.table = payload;
    },

    PAGINATION_CHANGED(state, payload) {
      state.pagination = payload || {};
    },

    PAGINATION_CURRENT_PAGE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: payload || 1,
        pageSize: previousPagination.pageSize || INITIAL_PAGE_SIZE,
      };
    },

    PAGINATION_PAGE_SIZE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: previousPagination.currentPage || 1,
        pageSize: payload || INITIAL_PAGE_SIZE,
      };
    },

    SORTER_CHANGED(state, payload) {
      state.sorter = payload || {};
    },

    FETCH_STARTED_IN_BACKGROUND(state, payload) {
      state.backgroundLoading = true;
      if (state.table) {
        state.table.clearSelection();
      }

      state.filter = payload && payload.filter ? payload.filter : {};
      state.pagination =
        payload && payload.keepPagination ? state.pagination : {};
    },

    FETCH_STARTED(state) {
      state.loading = true;

      // if (state.table) {
      //   state.table.clearSelection();
      // }

      // state.filter =
      //   payload && payload.filter ? payload.filter : {};
      // state.pagination =
      //   payload && payload.keepPagination
      //     ? state.pagination
      //     : {};
    },

    FETCH_SUCCESS(state) {
      state.loading = false;
      // state.backgroundLoading = false;
      // state.rows = payload.rows;
      // state.count = payload.count;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      // state.backgroundLoading = false;
      // state.rows = [];
      // state.count = 0;
    },

    EXPORT_STARTED(state) {
      state.exportLoading = true;
    },

    EXPORT_SUCCESS(state) {
      state.exportLoading = false;
    },

    EXPORT_ERROR(state) {
      state.exportLoading = false;
    },

    // //#region VuexfireMutations
    ...vuexfireMutations,
    SET_MOUNTEDTABLE(state, payload) {
      state.mountedTable = payload;
    },
    SET_LOADMORE_LAST(state) {
      // state.rows.pop()
      // console.log('state.rows',state.rows.pop());
      state.loadMoreLastRecord = state.rows[state.rows.length - 1]._doc;
      state.recordAfterLast = state.rows[state.rows.length - 1];
    },
    SET_LOADFIRSTRECORD(state) {
      state.loadFirstRecord = state.rows[0]._doc;
    },
    RESET_CURSOR(state) {
      state.loadMoreLastRecord = null;
      state.loadFirstRecord = null;
    },
    REMOVELASTELEMENT(state) {
      state.rows.pop();
    },
    SET_TOTAL_RECORDS(state, payload) {
      state.totalRecords = payload;
      state.pagesNumber = Math.ceil(state.totalRecords / 10);
    },
    SET_ROWS(state, payload) {
      state.rows = payload;
    },

    // //#endregion
  },

  actions: {
    doUnselectAll({ commit }) {
      commit("UNSELECT_ALL");
    },

    doMountTable({ commit }, table) {
      commit("TABLE_MOUNTED", table);
    },

    async doReset({ commit, dispatch }) {
      commit("RESETED");
      return dispatch("doFetch");
    },

    async doExport({ commit, getters }) {
      try {
        if (!jobListExporterFields || !jobListExporterFields.length) {
          throw new Error("jobListExporterFields is required");
        }

        commit("EXPORT_STARTED");

        const filter = getters.filter;

        await JobService.list(
          filter,
          getters.orderBy,
          null,
          null,
          (response) => {
            new Exporter(
              jobListExporterFields,
              "job"
            ).transformAndExportAsExcelFile(response.rows);
          }
        );

        // new Exporter(
        //   jobListExporterFields,
        //   'job',
        // ).transformAndExportAsExcelFile(response.rows);

        commit("EXPORT_SUCCESS");
      } catch (error) {
        Errors.handle(error);

        commit("EXPORT_ERROR");
      }
    },

    doChangePagination({ commit, getters, dispatch }, pagination) {
      commit("PAGINATION_CHANGED", pagination);
      const filter = getters.filter;
      dispatch("doFetch", { filter, keepPagination: true });
    },

    doChangePaginationPageSize({ commit, getters, dispatch }, pageSize) {
      commit("PAGINATION_PAGE_SIZE_CHANGED", pageSize);
      const filter = getters.filter;
      dispatch("doFetch", { filter, keepPagination: true });
    },

    doChangePaginationCurrentPage({ commit, getters, dispatch }, currentPage) {
      commit("PAGINATION_CURRENT_PAGE_CHANGED", currentPage);
      const filter = getters.filter;
      dispatch("doFetch", { filter, keepPagination: true });
    },

    doChangeSort({ commit, getters, dispatch }, sorter) {
      commit("SORTER_CHANGED", sorter);
      const filter = getters.filter;
      dispatch("doFetch", { filter, keepPagination: true });
    },

    async doGetRecordsCount({ commit }) {
      await firebase
        .database()
        .ref("stats/propertiesCount")
        .on("value", (snapshot) => {
          commit("SET_TOTAL_RECORDS", snapshot.val());
        });
    },

    // //#region vuexfire
    setMountedTable({ commit }, value) {
      commit("SET_MOUNTEDTABLE", value);
    },
    doFetch: firestoreAction(
      async ({ bindFirestoreRef, getters, commit }, payload) => {
        commit("FETCH_STARTED");
        const customSerializer = (doc) => {
          const data = doc.data();
          Object.defineProperty(data, "_doc", { value: doc });
          return data;
        };
        var db = firebase.firestore().collection("job");
        var jobCollection = null;
        if (payload.postStatus == "pending") {
          db = db.where("postStatus", "==", "pending");
        }
        if (payload.status == "hiring") {
          db = db.where("status", "==", "hiring");
        }

        switch (payload.searchBy) {
          case "name":
            jobCollection = getters.loadMoreLastRecord
              ? db
                  .orderBy("name", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .startAfter(getters.loadMoreLastRecord)
                  .limit(payload.limit || 10)
              : db
                  .orderBy("name", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .limit(payload.limit || 10);
            break;
          //#region []
          case "address":
            jobCollection = getters.loadMoreLastRecord
              ? db
                  .orderBy("address", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .startAfter(getters.loadMoreLastRecord)
                  .limit(payload.limit || 10)
              : db
                  .orderBy("address", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .limit(payload.limit || 10);
            break;
          case "phoneNumber":
            jobCollection = getters.loadMoreLastRecord
              ? db
                  .orderBy("phoneNumber", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .startAfter(getters.loadMoreLastRecord)
                  .limit(payload.limit || 10)
              : db
                  .orderBy("phoneNumber", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .limit(payload.limit || 10);
            break;
          case "emailAddress":
            jobCollection = getters.loadMoreLastRecord
              ? db
                  .orderBy("emailAddress", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .startAfter(getters.loadMoreLastRecord)
                  .limit(payload.limit || 10)
              : db
                  .orderBy("emailAddress", "asc")
                  .startAt(payload.filter)
                  .endAt(payload.filter + "\uf8ff")
                  .limit(payload.limit || 10);
            break;
          //#endregion
        }

        await bindFirestoreRef("rows", jobCollection, {
          serialize: customSerializer,
        });
        commit("FETCH_SUCCESS");
      }
    ),
    //
    doFetchFromRoute: firestoreAction(
      async ({ bindFirestoreRef, commit }, payload) => {
        commit("FETCH_STARTED");
        const customSerializer = (doc) => {
          const data = doc.data();
          Object.defineProperty(data, "_doc", { value: doc });
          return data;
        };

        // const db = firebase.firestore()
        // var jobCollection = null

        var db = firebase.firestore().collection("job");
        var jobCollection = null;
        if (payload.postStatus == "pending") {
          db = db.where("postStatus", "==", "pending");
        }
        if (payload.status == "hiring") {
          db = db.where("status", "==", "hiring");
        }

        // const startAt = payload.page * payload.limit - payload.limit
        const endAt = payload.page * payload.limit;
        // .startAt(payload.filter)
        // .endAt(payload.filter + "\uf8ff")

        const searchOptions = [
          "name",
          "emailAddress",
          "phoneNumber",
          "address",
        ];
        if (searchOptions.includes(payload.searchBy)) {
          jobCollection = db
            .orderBy(payload.searchBy, "asc")
            .limit(endAt)
            .where(payload.searchBy, ">=", payload.filter)
            .where(payload.searchBy, "<", payload.filter + "\uf8ff");
        } else {
          jobCollection = db.orderBy("createdAt", "desc").limit(endAt);
        }

        await bindFirestoreRef("rowsFromRoute", jobCollection, {
          serialize: customSerializer,
        });
        // var rowsFromRouteToBeDisplayed = getters.rowsFromRoute.slice(payload.page * payload.limit - payload.limit , payload.page * payload.limit + 1)
        // commit('SET_ROWS',rowsFromRouteToBeDisplayed)
        commit("FETCH_SUCCESS");
      }
    ),
    setRows({ commit }, payload) {
      commit("FETCH_STARTED");
      commit("SET_ROWS", payload);
      commit("FETCH_SUCCESS");
    },

    setLoadMoreLast({ commit }) {
      commit("SET_LOADMORE_LAST");
    },
    resetCursor({ commit }) {
      commit("RESET_CURSOR");
    },
    setLoadFirstRecord({ commit }) {
      commit("SET_LOADFIRSTRECORD");
    },
    removeLastElement({ commit }) {
      commit("REMOVELASTELEMENT");
    },
    getPreviousRecordsBatch: firestoreAction(
      async ({ bindFirestoreRef, getters }, payload) => {
        const customSerializer = (doc) => {
          const data = doc.data();
          // console.log('go to Previous ====>',data.name);
          Object.defineProperty(data, "_doc", { value: doc });
          return data;
        };
        // const db = firebase.firestore()
        // var jobCollection = null

        var db = firebase.firestore().collection("job");
        var jobCollection = null;
        if (payload.postStatus == "pending") {
          db = db.where("postStatus", "==", "pending");
        }
        if (payload.status == "hiring") {
          db = db.where("status", "==", "hiring");
        }

        switch (payload.searchBy) {
          case "name":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
          case "address":
            jobCollection = db
              .orderBy("address", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
          case "postStatus":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("postStatus", "==", "pending")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
          case "status":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("status", "==", "hiring")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
          case "phoneNumber":
            jobCollection = db
              .orderBy("phoneNumber", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
          case "emailAddress":
            jobCollection = db
              .orderBy("emailAddress", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(payload.limit || 10);
            break;
        }
        await bindFirestoreRef("rows", jobCollection, {
          serialize: customSerializer,
        });
      }
    ),
    setDisableNext: firestoreAction(
      async ({ getters, bindFirestoreRef }, payload) => {
        // const db = firebase.firestore()

        var db = firebase.firestore().collection("job");
        var jobCollection = null;
        if (payload.postStatus == "pending") {
          db = db.where("postStatus", "==", "pending");
        }
        if (payload.status == "hiring") {
          db = db.where("status", "==", "hiring");
        }

        switch (payload.searchBy) {
          case "name":
            jobCollection = db
              .limit(1)
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .startAfter(getters.loadMoreLastRecord);
            break;
          case "address":
            jobCollection = db
              .limit(1)
              .orderBy("address", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .startAfter(getters.loadMoreLastRecord);
            break;
          case "postStatus":
            jobCollection = db
              .limit(1)
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("postStatus", "==", "pending")
              .startAfter(getters.loadMoreLastRecord);
            break;
          case "status":
            jobCollection = db
              .limit(1)
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("status", "==", "hiring")
              .startAfter(getters.loadMoreLastRecord);
            break;
          case "phoneNumber":
            jobCollection = db
              .limit(1)
              .orderBy("phoneNumber", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .startAfter(getters.loadMoreLastRecord);
            break;
          case "emailAddress":
            jobCollection = db
              .limit(1)
              .orderBy("emailAddress", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .startAfter(getters.loadMoreLastRecord);
            break;
        }
        await bindFirestoreRef(
          "recordAfterLast",
          jobCollection
          // ,
          // { serialize: customSerializer }
        );
      }
    ),
    setDisablePrevious: firestoreAction(
      async ({ getters, bindFirestoreRef }, payload) => {
        // const db = firebase.firestore()
        // var jobCollection = null

        var db = firebase.firestore().collection("job");
        var jobCollection = null;
        if (payload.postStatus == "pending") {
          db = db.where("postStatus", "==", "pending");
        }
        if (payload.status == "hiring") {
          db = db.where("status", "==", "hiring");
        }

        switch (payload.searchBy) {
          case "name":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
          case "address":
            jobCollection = db
              .orderBy("address", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
          case "postStatus":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("postStatus", "==", "pending")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
          case "status":
            jobCollection = db
              .orderBy("name", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .where("status", "==", "hiring")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
          case "phoneNumber":
            jobCollection = db
              .orderBy("phoneNumber", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
          case "emailAddress":
            jobCollection = db
              .orderBy("emailAddress", "asc")
              .startAt(payload.filter)
              .endAt(payload.filter + "\uf8ff")
              .endBefore(getters.loadFirstRecord)
              .limitToLast(1);
            break;
        }
        await bindFirestoreRef(
          "recordBeforeFirst",
          jobCollection
          // ,
          // { serialize: customSerializer }
        );
        // console.log('recordBeforeFirst',getters.recordBeforeFirst);
      }
    ),
    doFetchUserJob: firestoreAction(
      async ({ bindFirestoreRef, commit }, payload) => {
        commit("FETCH_STARTED");
        const db = firebase.firestore();
        const jobCollection = db
          .collection("job")
          .where("createdBy", "==", payload.userId);
        await bindFirestoreRef("userJobs", jobCollection);
        commit("FETCH_SUCCESS");
      }
    ),

    // unbindJobs: firestoreAction(({ unbindFirestoreRef }) => {
    //   unbindFirestoreRef('rows', true)
    //   unbindFirestoreRef('userJobs', true)

    // }),
    // //#endregion

    // async doFetch(
    //   { commit, getters },
    //   { filter, keepPagination } = {},
    // ) {
    //   try {
    //     commit('FETCH_STARTED', { filter, keepPagination });

    //     const response = await JobService.list(
    //       filter,
    //       getters.orderBy,
    //       // getters.limit,
    //       // getters.offset,
    //     );

    //     commit('FETCH_SUCCESS', {
    //       rows: response.rows,
    //       count: response.count,
    //     });
    //   } catch (error) {
    //     Errors.handle(error);
    //     commit('FETCH_ERROR');
    //   }
    // },

    async doFetchInBackground(
      { commit, getters },
      { filter, keepPagination } = {}
    ) {
      try {
        commit("FETCH_STARTED_IN_BACKGROUND", { filter, keepPagination });

        const response = await JobService.list(
          filter,
          getters.orderBy
          // getters.limit,
          // getters.offset,
        );

        commit("FETCH_SUCCESS", {
          rows: response.rows,
          count: response.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit("FETCH_ERROR");
      }
    },
  },
};
